import React from 'react'
import styled from '@emotion/styled'

import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {BottomSheet} from '@vio/atlas/src/components/designSystem/BottomSheet'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {CarsIcon} from './assets/CarsIcon'
import {ExtrasIcon} from './assets/ExtrasIcon'
import {FlightsIcon} from './assets/FlightsIcon'
import {HotelsIcon} from './assets/HotelsIcon'
import {LastMinuteIcon} from './assets/LastMinuteIcon'
import {MagazineIcon} from './assets/MagazineIcon'
import {navItemsMessages} from './messages'
import {getNavItemLinkProps, type NavItem} from './navItems'

const NavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

const NavItemLink = styled.a<{isActive?: boolean}>`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s400};
  padding: ${cssTheme.layout.spacing.s400} ${cssTheme.layout.spacing.s500};
  text-decoration: none;
  color: ${({isActive}) =>
    isActive
      ? cssTheme.colors.content.brand.primary
      : cssTheme.colors.content.neutral.primary};
  font-size: ${cssTheme.fonts.size.md};

  &:hover {
    text-decoration: none;
    color: ${cssTheme.colors.content.brand.primary};
  }
`

const FooterWrapper = styled.div`
  position: relative;
  padding: ${cssTheme.layout.spacing.s500};
`

const iconMap: Record<string, React.ComponentType<{size?: number}>> = {
  flights: FlightsIcon,
  cars: CarsIcon,
  hotels: HotelsIcon,
  magazine: MagazineIcon,
  extras: ExtrasIcon,
  lastMinute: LastMinuteIcon
}

interface Props {
  isOpen: boolean
  onClose: () => void
  navItems: NavItem[]
}

export const MobileNavSheet = ({isOpen, onClose, navItems}: Props) => (
  <BottomSheet
    navBarProps={{variant: 'transparent', floating: true}}
    isOpen={isOpen}
    prefersReducedMotion
    isModal
    disableDrag
    onClose={onClose}
    noPaddings
    footerContent={
      <FooterWrapper>
        <Button variant="tertiary" fullWidth onClick={onClose}>
          <FormattedMessageWrapper id="close" defaultMessage="Close" />
        </Button>
      </FooterWrapper>
    }
  >
    <Box paddingTop="s900" paddingBottom="s400">
      <NavList>
        {navItems.map(item => {
          const Icon = iconMap[item.id]

          return (
            <li key={item.id}>
              {item.isActive ? (
                <NavItemLink as="span" isActive>
                  {Icon && <Icon size={20} />}
                  <FormattedMessageWrapper {...navItemsMessages[item.id]} />
                </NavItemLink>
              ) : (
                <NavItemLink {...getNavItemLinkProps(item)}>
                  {Icon && <Icon size={20} />}
                  <FormattedMessageWrapper {...navItemsMessages[item.id]} />
                </NavItemLink>
              )}
            </li>
          )
        })}
      </NavList>
    </Box>
  </BottomSheet>
)
